export default __webpack_public_path__ + "static/media/lens_login.d1df5ef2.svg";